var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.800781H31.2M31.2 0.800781V32.0008M31.2 0.800781L0 32.0008",
    stroke: "black",
    strokeWidth: 1.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLink);
export default __webpack_public_path__ + "static/media/arrowLink.0ce15e342f015aac7c101f9a6585511a.svg";
export { ForwardRef as ReactComponent };